import React from 'react';
import './Hero3.css';
import serverUrl from '../../constants/serverUrl';

const Hero3 = (props) => {
  const { title, subtitle, img } = props;
  const imgSrc = serverUrl + img;
  console.log(imgSrc, 'Hero3 image source');
  return (
    <div className="hero-3">
      <div className="hero-3-content container">
        <div className="hero-3-text">
          <h2 className="hero-3-title">
            {title}
          </h2>
         <div
            className="hero-3-main-text"
            dangerouslySetInnerHTML={{ __html: subtitle }}
            style={{ color: '#fff' }}
          />
        </div>
      </div>
      <div className="hero-3-image">
        <img
          src={imgSrc}
          alt="Hero Background"
          className="hero-3-img"
        />
      </div>
    </div>
  );
};

export default Hero3;


// WEBPACK FOOTER //
// src/components/Hero3/Hero3.js